import styled, { css } from 'styled-components';

import { Row as BasicRow } from '@/components/Row';

export const Row = styled(BasicRow)`
  margin: 0 auto;
  text-align: center;
  margin-bottom: 117px;

  ${({ theme }) => css`
    grid-gap: ${theme.spacing(2)};

    ${theme.media.md.up} {
      max-width: 388px;
    }
  `}
`;
export const CustomerRow = styled(BasicRow)`
  max-width: 778px;
  margin: 0 auto 32px auto;
`;
